export default "__VITE_ASSET__a5377e6c__"